<template>
  <div class="gallery-container">
    <div class="gallery row">
      <div class="row w-100 mx-0">
        <!-- Images -->
        <div
          v-for="(data, index) in dataGallery"
          :key="'img-' + index"
          class="gallery-item col-xl-6 col-12 pb-3"
          @click="openModal(index, 'image')"
        >
          <div class="gallery-item-wrapper">
            <img :src="data.Url.substr(0, data.Url.lastIndexOf('.'))+'_mini'+data.Url.substr(data.Url.lastIndexOf('.')).trim()" />
            <div class="gallery-overlay">
              <i class="fa-solid fa-expand"></i>
            </div>
          </div>
        </div>
        <!-- Videos -->
        <div
          v-if="dataGalleryVideo"
          v-for="(data, index) in dataGalleryVideo"
          :key="'vid-' + index"
          class="gallery-item col-xl-6 col-12 pb-3"
          @click="openModal(index, 'video')"
        >
          <div class="gallery-item-wrapper">
            <video width="100%" height="auto">
              <source :src="data.Url" type="video/mp4">
            </video>
            <div class="gallery-overlay">
              <i class="fa-solid fa-play"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalGallery
      :show="showModal"
      :items="allItems"
      :index="modalIndex"
      @close="closeModal"
      @prev="prevItem"
      @next="nextItem"
    />
  </div>
</template>

<script>
import ModalGallery from './ModalGallery.vue';

export default {
  components: {
    ModalGallery
  },
  props: [
    "dataGallery",
    "dataGalleryVideo"
  ],
  data() {
    return {
      activeSlide: 0,
      showModal: false,
      modalIndex: 0,
      currentItemType: 'image',
    };
  },
  computed: {
    allItems() {
      const items = [];
      if (this.dataGallery) {
        this.dataGallery.forEach((item, index) => {
          let url = item.Url || '';
          url = url.substr(0, url.lastIndexOf('.')) + '_std' + url.substr(url.lastIndexOf('.'));
          items.push({
            url: url,
            type: 'image',
            originalIndex: index
          });
        });
      }
      if (this.dataGalleryVideo) {
        this.dataGalleryVideo.forEach((item, index) => {
          items.push({
            url: item.Url,
            type: 'video',
            originalIndex: index
          });
        });
      }
      return items;
    }
  },
  methods: {
    openModal(index, type) {
      if (type === 'image') {
        this.modalIndex = index;
      } else {
        this.modalIndex = (this.dataGallery?.length || 0) + index;
      }
      this.currentItemType = type;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    prevItem() {
      if (this.modalIndex > 0) {
        this.modalIndex--;
      } else {
        this.modalIndex = this.allItems.length - 1;
      }
    },

    nextItem() {
      if (this.modalIndex < this.allItems.length - 1) {
        this.modalIndex++;
      } else {
        this.modalIndex = 0;
      }
    },

    goToSlide(index) {
      this.activeSlide = index;
    },
    scrollLeft() {
      this.$refs.thumbnails.scrollBy({ left: -100, behavior: "smooth" });
    },
    scrollRight() {
      this.$refs.thumbnails.scrollBy({ left: 100, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.gallery-container {
  width: 100%;
}

.gallery {
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
  gap: 15px;
  padding: 10px;
}

.gallery-item {
  padding: 0 5px;
}

.gallery-item-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: var(--radius);
  cursor: pointer;
}

.gallery-item-wrapper img,
.gallery-item-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-item-wrapper:hover img,
.gallery-item-wrapper:hover video {
  transform: scale(1.05);
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item-wrapper:hover .gallery-overlay {
  opacity: 1;
}

.gallery-overlay i {
  color: white;
  font-size: 2rem;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

@media (max-width: 576px) {
  .gallery-item-wrapper {
    aspect-ratio: 4 / 3;
  }
}
</style>
